
document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;

  // Default class on page load
  body.classList.add('toast');

  const toastClasses = {
    Toast: 'toast',
    Toasty: 'toasty',
    Toastier: 'toastier',
    Toastiest: 'toastiest'
  };

  const firstFieldset = document.querySelector('fieldset');
  if (!firstFieldset) return;

  document.addEventListener('click', (e) => {
    const input = e.target;
    if (
      input?.tagName !== 'INPUT' ||
      !firstFieldset.contains(input)
    ) {
      return;
    }

    // Remove all toast-related classes
    body.classList.remove(...Object.values(toastClasses));

    // Add matching class (if any)
    const newClass = toastClasses[input.value];
    if (newClass) {
      body.classList.add(newClass);
    }
  });
});

